// extracted by mini-css-extract-plugin
export default {"userDashBoard":"UserDashBoard_userDashBoard__+uYit","left":"UserDashBoard_left__f3g5F","icon":"UserDashBoard_icon__iL6iZ","right":"UserDashBoard_right__6UeMN"};